export default {
  activity: {
    type: ['', '个人', '中国移动香港', '中国移动国际', '其他企业', '青少年团体'],
    bg: 'static/newYear/WebSC-06_340x200.jpg',
    department: ['业务交付中心', '公司事务部', '企业客户销售部', '客户体验管理部\n', '客户服务部\n', '财务部\n', '人力资源部\n',
      '资讯科技部\n', '内审部\n', '法律及监管部\n', '市场部\n', 'MyLink部\n', '网络部\n', '网络优化部\n', '计划建设部\n',
      '新业务部 \n', '采购及供应链部\n', '销售部 \n', '战略部'],
    linkLabel: '详情 >',
    tips: '此为必填栏位',
    phone: '请输入正确联络电话 ',
    email: '请输入正确电邮格式',
    nameErr: '請輸入正确中文全名',
    go: '明白并继续',
    applicable: '(如适用)',
    link: '/mylink/?currentGroup=0&currentContent=0&ishshhkhiking=1&isPark=0&sightname=鹿颈鸡谷树下 至 新娘潭路&lang=sc&/#/xingshan/route/12',
    'activity1': '4.14 远足植树日2019',
    'activity2': '远足植树日',
    'activity3': '远足植树日',
    'activity4': '全港动起来 向健康出发 为健康一齐行',
    'activity5': '活动日期: 2019.4.14 （星期日）',
    'activity6': [
      '报名日',
      '报名截止',
      '活动日',
      '中午'
    ],
    'activity7': '活动详情',
    'activity8': [
      '由中国移动香港及中国香港旅行远足联会主办，秉承「为健康，一齐行」的信念，举办远足植树日（亦同为渔护署的“郊野公园远足植树日2019”）以推动全港市民参与，增进市民远足步行的健康意识为长远目标，并透过亲手植树加强对自然环境的了解和保护意识。',
      '',
      '远足植树日鼓励市民在4月14日结伴参与，在节日亲亲大自然。当日亦会举办远足植树「万步有礼」活动，鼓励全港市民在全港任何一个角落一齐行，齐齐强身健体。',
      '  ',
      '举行日期 : 2019年4月14日（星期日）',
      '活动时间：上午9时至中午12时',
      '报名日期：2019年3月26日 12:00（先到先得）',
      '',
      '活动秘书处：',
      '电话：2127 4720（星期一至五早上10时至晚上7时）',
      '电邮：wewalk.enquiry@gmail.com',
      '',
      '*由於植树场地有限，每组参加者将有机会获派一棵树苗作植树'
    ],
    'activity9': '活动路径',
    'activity10': '远足地点：凤坑家乐径',
    activityTree: '植树地点：八仙岭自然教育径',
    'activity11': '远足路线：鹿颈鸡谷树下 至 新娘潭路',
    'activity12': '行程：约1小时',
    'activity13': '长度：2公里',
    'activity14': '费用：全免',
    'activity15': '交通',
    'activity16': [
      '自行乘坐公共交通工具到达集合地点，或乘坐大会专车由九龙塘出发前往',
      '公共交通：从大埔墟站乘搭275R号巴士或20R号专线小巴至新娘潭站下车'
    ],
    'activity18': '立即报名',
    'activity19': '远足植树日行山活动2019',
    'activity20': '邀你报名',
    'activity21': '「远足植树日2019」万步有礼活动',
    'activity22': [
      '大会除了举办「远足植树日2019」活动，亦鼓励全港市民在全港任何一个角落一齐行，以健康的体魄迎接新一年，特意举办「万步有礼」活动。',
      '全港市民只要在4月14日当日开启并登入MyLink手机应用程式，透过WeWalk页面内的计步功能并步行够一万步，即可参加活动。',
      '',
      '参加方法',
      '1. 登入MyLink',
      '2. 开启「生活」内 WeWalk 页面',
      '3. 当天行满一万步后，计步器将会发出提示',
      '',
      '奖品',
      '参加者只要成功在4月14 日行满10,000步后，即可获赠10,000 MyLink积分。 （名额共1,000名，先到先得）',
      '电话：2127 4720 (星期一至五早上10时至晚上7时)',
      '电邮：wewalk.enquiry@gmail.com'
    ],
    'activity23': '报名时间已结束',
    'activity24': '反应热烈，是次活动名额已满，多谢支持！',
    'activity25': '参与活动成功！',
    'activity26': '活动参与信息如下：',
    'activity27': [
      '参与组别：',
      '企业/机构名称：',
      '组长：',
      '联络电话：',
      '额外参加者：',
      '主办机构于活动前透过MyLink手机应用程式及电邮发出提示，届时请留意活动最新资讯。'
    ],
    'activity28': '活动报名',
    'activity29': '请选择报名组别',
    'activity30': '个人',
    'activity31': '企业/机构',
    'activity32': '名额已满',
    'activity33': '活动报名',
    'activity34': '邀请码',
    'activity35': '请输入邀请码',
    'activity36': '邀请码无效，如有疑问请联络活动秘书处。',
    'activity37': '活动报名',
    'activity38': '企业/机构名称',
    'activity39': '请输入企业/机构名称',
    'activity40': '所属部门(按英文字母顺序排列)',
    'activity41': '请选择所属部门',
    'activity42': '员工编号',
    'activity43': '请输入员工编号',
    'activity44': '姓名',
    'activity45': '请输入中文全名',
    'activity46': '年龄',
    'activity47': '请选择年龄',
    'activity48': '18-69岁',
    'activity49': '6-17岁',
    'activity50': '5岁或以下',
    'activity51': '70岁或以上',
    'activity52': '家长',
    'activity53': '监护人',
    'activity54': '家长/监护人姓名',
    'activity55': '请输入家长/监护人姓名',
    'activity56': '本人声明本人已年满18岁（年龄以活动当日计算）。本人及同行参加者细阅并同意本活动之「参加者须知及条款细则」、「免责声明」及「个人资料收集声明」。主办机构保留取消不接受上述条款之参加者的参加资格。',
    'activity57': '参加者年龄必须为6岁或以上',
    'activity58': '参加者必须自行评估身体状况，确保体格适宜参加活动。如有疑问，请先谘询医生意见。',
    'activity59': '联络电话',
    'activity60': '请输入联络电话',
    'activity61': '电邮',
    'activity62': '请输入你的电邮',
    'activity63': '紧急联络人',
    'activity64': '请输入紧急联络人姓名',
    'activity65': '紧急联络人联络电话',
    'activity66': '请输入紧急联络人联络电话',
    'activity67': '紧急联络人资料同上',
    'activity68': '额外参加者（限X人）',
    'activity69': '添加额外参加者',
    'activity70': [
      '本人同意参加者参加「远足植树日2019」活动，亦證明本活动参加表格内提供的资料全部属实。本人已知悉全部声明内容，如有违反概由本人负责所有责任。',
      ''
    ],
    'activity71': '提交',
    'activity72': '资料一经提交不可修改，确定提交？',
    'activity73': '取消',
    'activity74': '确定',
    'activity75': '紧急联络人资料与参加者相同，请重新输入',
    'activity76': '紧急联络人资料与参加者相同，请重新输入',
    'activity77': '参加者资料重覆，请重新输入',
    'activity78': '抱歉，当前剩馀报名名额不足，请删除部分参加者再重试',
    'activity80': '另外查收文案'
  },
  weWalk: {
    start: '活动将于4月14日开始！',
    'weWalk1': '万步有礼',
    'weWalk2': '活动时间：4月14日',
    'weWalk3': '活动介绍',
    'weWalk4': [
      '大会除了举办「万步有礼」活动，亦鼓励全港市民在全港任何一个角落一齐行，以健康的体魄迎接新一年，特意举办「万步有礼」活动。',
      '全港市民只要在4月14日当日开启并登入MyLink手机应用程式，透过WeWalk页面内的计步功能并步行够一万步，即可参加活动。'
    ],
    'weWalk5': '活动规则',
    'weWalk6': [
      '登入MyLink',
      '开启「生活」内 WeWalk 页面',
      '当天行满一万步后，计步器将会发出提示（名额共1,000名，先到先得）'
    ],
    'weWalk7': '如何打开MyLink计步器参与活动？',
    'weWalk8': [
      '参与活动前，请查看生活-WeWalk页面步数信息是否显示正确（今日步数应大于0），如下图：',
      ['如有问题，请点此', '查看原因']
    ],
    'weWalk9': ['查看', '活动条款及细则'],
    'weWalk10': '(請參閱電郵附件)',
    'weWalk11': '活动已结束',
    'weWalk12': '远足植树日万步有礼',
    'weWalk13': '邀请参与万步有礼活动',
    'weWalk14': '查阅活动纪录',
    'weWalk15': '活动条款及细则',
    'weWalk16': '(請另參閱電郵附件)',
    'weWalk17': '活动结果',
    'weWalk18': '欢迎阁下参与活动',
    'weWalk19': '活动期间累积步数：',
    'weWalk20': '今日步数',
    'weWalk21': 'XXX步',
    'weWalk22': '查阅详细纪录',
    'weWalk23': ['距离获得积分还差 ', ' 步，继续加油哦！'],
    'weWalk24': '邀请好友参与',
    'weWalk25': ['查看', '活动详情'],
    'weWalk26': ['在万步有礼活动中已获得', ' MyLink积分'],
    'weWalk27': '阁下已领取MyLink积分，感谢参与！',
    'weWalk28': '兑换礼品',
    'weWalk29': '万步有礼活动',
    'weWalk30': '远足植树日最新消息:',
    'weWalk31': ['因天文台已经发出恶劣天气警告，原订今早举行之活动将会取消。',
      '「万步有礼」活动则如常进行，敬希垂注。查询可致电：2127 4720']
  },
  sign: {
    'route': '凤坑家乐径 (鹿颈鸡谷树下 至 新娘潭路)',
    'sign1': '现场签到中...',
    'sign2': '远足植树日2019',
    'sign3': [
      '植树地点：八仙岭自然教育径',
      '远足路线：凤坑家乐径 (鹿颈鸡谷树下 至 新娘潭路)',
      ''
    ],
    'sign4': '签到',
    'sign5': '未能查询阁下参与活动信息，请与工作人员联络。',
    'sign6': '阁下已签到！',
    'sign7': '2019年4月14日 xx:xx',
    'sign8': '姓名：',
    'sign9': '电话：',
    'sign10': '已选：',
    'sign11': '额外参与人员：',
    'sign12': '签到结果',
    'sign13': '抱歉',
    'sign14': '请活动队长扫描QR Code以签到',
    'sign15': '签到信息确认',
    'sign16': '活动确认信息如下：',
    'sign17': '额外人员',
    'sign18': '一经签到后，人数不能改变！',
    'sign19': '取消',
    'sign20': '提交',
    'sign21': '登记结果',
    'sign22': '系统错误，请稍后再试！',
    'sign23': '签到结果',
    'sign24': '阁下已签到！'
  },
  activityRules: {
    content: ['本人声明本人已年满18岁（年龄以活动当日计算）。本人及同行参加者细阅并同意本活动之',
      '「参加者须知及条款细则」',
      '、',
      '「免责声明」',
      '及',
      '「个人资料收集声明」',
      '。主办机构保留取消不接受上述条款之参加者的参加资格。',
    ],
    rule1: {
      title: '参加者须知及条款细则',
      content: [{
        title: '',
        list: ['「远足植树日2019」由中国移动香港有限公司 (「中国移动香港」) 及中国香港旅行远足联会 (「旅联」) 联合主办。',
          '在下列的条款及细则内「活动」乃指2019年4月14日举行的「远足植树日2019」行山活动；「所有参加者」包括所有参加者及额外参加者；「参加者」为参与是次活动并已年满18岁（年龄以活动当日计算）的人士；「额外参加者」为参加者于报名时所申报同行的人士；「主办机构」为中国移动香港及旅联；「路线」是由主办机构指定的行山路线；「MyLink」乃指由中国移动香港推出的MyLink手机应用程式。',
          '活动于2019年3月26日开始在MyLink接受报名，采用先到先得形式报名，额满后即时停止接受登记，亦不设候补名单。主办机构恕不接受MyLink以外的途径报名。',
          '每名参加者可携同一名额外参加者同行。报名者将是该组参加者的组长。',
          '参与活动确认一经递交，即代表参加者及额外同行参加者确认及同意接受一切主办机构不时所定之活动的规则、条款和安排。',
          '18岁以下的额外参加者必须于报名时同时完成由家长/监护人填写之家长/监护人同意书。',
          '报名后一切资料不得更改。',
          '参加者必须于活动期间内使用其香港注册的流动电话号码注册并登入MyLink参加本活动，每名参加者只限参加活动一次。如发现参加者以外挂程式或其他非正式途径如空号或假帐户或其他影响公平性的方式参加本活动，中国移动香港将取消该参加者的资格而不作另行通知。',
          '参加者必须于Google Play 或 App Store 下载MyLink。中国移动香港客户（包括现有的储值卡客户、服务计划客户及用身份证登记的企业客户）需以电话号码及密码或一次性密码登入MyLink；MySim客户及非中国移动客户需以电话号码及密码登入MyLink。如以验证码登入，参加者必须提供支援短讯功能的香港手机号码。',
          '如参加者需注册成为MyLink用户，参加者必须提供支援短讯功能的香港手机号码以获得一次性验证码进行身份验证。如登记的手机号码不支援短讯功能或不能使用、无效或在报名确认时已经更改，该参加者会被取消资格。',
        ]
      }, {
        title: '活动细节',
        list: ['活动会先进行植树活动，起点为八仙岭自然教育径新娘潭路入口，步行至指定植树地点。参加者必须于活动当日年满18岁。额外参加者必须于活动当日年满6岁。每名18岁以下的额外参加者必须事先获家长或监护人签署同意书方可参加。主办机构保留在活动前后或进行期间，核实参加者及额外参加者的年龄及(如有需要)要求出示该等同意书证明的权利。',
          '树苗及种植工具将在起点时派发。树苗数量有限，派完即止。主办机构派发树苗时会尽量以每组参加者为单位，惟不保证每名参加者均可获发树苗。',
          '所有参加者须遵守主办机构代表之植树程序及规则植树。主办机构会提供基本工具，惟强烈建议参加者自行带备劳工手套及其他保护工具。',
          '植树部分完毕后，主办机构将带领所有参加者沿路下山回到起点，再前往凤坑家乐径进行行山活动。起点位于鹿颈鸡谷树下，终点位于新娘潭路。凤坑家乐径与植树地点有一段距离，所有参加者可自行选择是否参与。',
          '所有参加者成功报名参与活动后，将会收到主办机构的确认电邮，要求所有参加者须在电邮所述的限期前申报病历记录，以便主办机构知悉。',
          '主办机构在得悉或怀疑情况下，保留拒绝接受报名或取消任何不适宜参加本活动人士的参加资格的权利，包括但不限于如参加者于活动当日年龄不足18岁、额外参加者于活动当日年龄不足6岁、提供错误资料、不能提交报名表、不依从正确报名程序报名、或身体状况不适宜参加本活动（如怀有身孕、患慢性疾病如心脏病及高血压人士）。',
          '所有参加者必须最迟于活动当天上午9时抵达新娘潭路狮子亭，逾时者会被取消参加资格。若所有参加者未能按照其指定参加组别及时间起步，或未能依循所报名的路线完成活动，主办机构有权取消其参加资格。',
          '所有参加者不可携带或使用任何滚轴鞋、滑板、手推车或其他大型物件，亦不可携同任何动物参与。',
          '所有参加者于活动前后及进行期间，必须遵照主办机构、授权人员以及其他工作人员包括警察、民众安全服务队、医疗辅助队、食物环境卫生署、康乐文化事务署及渔农自然护理署的所有合法指示。',
          '所有参加者请于活动期间保持礼貌的态度。',
          '步毕路线全程约2小时。沿途有上山路程，部分地区并无遮盖，所有参加者需确保体力适宜才参与，如有疑问，应先向医生查询。植树地点位于山区，参加者须步行前往。活动实际完结时间以主办机构及授权人员所安排的押尾小队决定为准。',
          '所有参加者需穿上合适的衣服及鞋袜，并自备充足饮品、食物、帽及雨具等。',
          '是次行山活动途径泥路小径，所有参加者须特别小心。请勿奔跑、争先恐后、倚靠或攀爬沿途任何物件，以确保安全。',
          '所有参加者须清楚明白本活动内容及性质，并知道本活动需要消耗体力，同时确定健康情况适宜参与本活动。主办机构建议所有参加者于活动期间自行留意个人的身体状况是否良好及是否适合参与本活动。所有参加者于活动期间如有不适，请立即停止活动，并按需要向医护人员求助。',
          ['主办机构强烈建议所有参加者出发前先行搜集路线的资讯，并细阅渔农自然护理署网页发布的《郊野公园远足安全指引》。',
            '《郊野公园远足安全指引》：',
            'http://www.afcd.gov.hk/tc_chi/country/cou_vis/cou_vis_gac/cou_wha_whe_sat.html'],
          ['主办机构不保证路线全程均有流动网络覆盖及/或有紧急救助电话。主办机构强烈建议所有参加者结伴同行，带备手提电话后备电池、外置电源及/或对讲机。主办机构强烈建议参加者于出发前细阅渔农自然护理署网页上的《郊野公园设施最新消息》，并不要前往《郊野公园曾发生致命及严重意外的高危地点》中所列出的所有地点。',
            '《郊野公园设施最新消息》：',
            'https://www.hiking.gov.hk/pathinfo/announcement.php',
            '《郊野公园曾发生致命及严重意外的高危地点》：',
            'https://www.hiking.gov.hk/fatal_and_accident_case/index_tc.htm'],
          '参加者需自行承担参与活动的一切责任。主办机构及授权机构并不会对所有参加者于活动当天因任何事情或理由所引致的任何个人伤亡或财物损失承担任何责任。',
          '主办机构保留更改本条款及细则、其他活动细节、如路线等安排的权利。',
          '主办机构若认为任何参加者或额外参加者没有完全遵照或违反本条款及细则的规定、以不诚实手法参加或进行本活动及/或造假者，主办机构有权取消该参加者或者额外参加者的资格或于行山活动中任何时间内终止该参加者或者额外参加者继续参加，而不作任何通知，并对任何违反行为保留追究权利。如有任何争议，主办机构所作的决定为最终及不可推翻。',
        ]
      }, {
        title: '恶劣天气',
        list: ['如天文台于活动当日早上六时或之后悬挂黑色暴雨、红色暴雨、雷暴或三号台风警告，或因天气恶劣、任何天气警告生效或其他原因而导致活动取消，主办机构有权另择日子举行活动，或决定取消活动而不补办。',
          '如活动进行期间天气恶劣或悬挂上述任何天气警告，又或主办机构评估后判断当天并不适合举行活动，主办机构有权将活动路径改变或取消正在进行中的活动。主办机构不会另择日子补办活动。',
          '主办机构强烈要求所有参加者于活动举行当天早上致电香港天文台查询天气情况。 (电话：1878200)',
        ]
      }, {
        title: '其他事宜',
        list: ['主办机构不会提供行李寄存。切勿携带贵重物品，如有损毁或遗失，主办机构将不会负任何责任及作出任何赔偿。',
          '所有参加者如活动过程中须向主办机构查询及要求协助，请沿途与就近工作人员联络。',
          '所有由主办机构提供的活动包、礼品及任何其他物品(「礼品」)不可兑换现金，亦不能更换、退款、转让及转售。本活动所有的礼品视乎供应情况而定，换领完即止。每名参加者或者额外参加者只可领取一份活动包，不可代他人领取。如任何因礼品所引起的争议，主办机构概不负责。',
          '主办机构已就活动购买第三者保险。主办机构建议所有参加者需自行购买个人意外保险。如参加者于活动开始前没有于MyLink手机应用程式作电子签到，则不获活动第三者保险保障。',
          '主办机构保留使用活动当天所拍得照片或录像的权利，包括商业宣传用途。',
          '主办机构保留本活动的最终决定权。活动不设上诉机制。主办机构拥有修改及解释本条款及细则的权利，任何有关活动的临时改动或取消，将以主办机构公布为准。',
          '本条款及细则受香港法律管辖。所有参加者同意任何因本条款及细则所引起的任何诉讼或索赔受香港法院的专属司法管辖权管辖。',
          '本条款及细则的中、英文版如有任何歧义，概以英文版为准。',
          '如有任何争议，主办机构将保留一切最终决定权。'
        ]
      }]
    },
    rule2: {
      title: '免责声明',
      p: '谨此声明本人参加本活动，并愿意遵守由主办机构所订的条文及规则，以及同意以下所列各点：',
      list: ['本人是自愿参加此活动和愿意承担自身的意外风险及责任，并无权向主办机构对本人往返活动场地途中、活动中发生或引致之自身意外、死亡或任何形式的损失提出索偿或追讨责任。',
        '本人声明本人身体情况良好及有能力参加此活动，及没有执业医生曾提出相反意见。',
        '本人愿意接受主办机构要求及提供的药物检查及治疗。',
        '本人于活动当天（2019年4月14日）已经符合参加组别之最低年龄规定（如参加者未年满18岁，须由其家长或监护人签署同意声明）。',
        '本人明白及同意本人的个人资料将转交予主办机构用作活动安排之用途。',
        '本人证实已事先获得同行参加者及/或紧急联系人的同意，可使用其个人资料于本活动的报名表格作报名及/或紧急联系用途。',
        '本人愿意授权予及同意主办机构及传媒在不需要审查情况及不需要本人另外同意下而可使用本人的个人资料、肖像、姓名及声线作为筹办及推广活动之用，包括本人肖像及姓名有可能被使用于主办机构有关本活动之网页、短片及刊物。',
        '本人提交确认即表示同意及确认所有列明之「参加者须知及条款细则」、「免责声明」及「个人资料收集声明」，以及所有不时于活动指定宣传渠道更新的任何更改。',
      ]
    },
    rule3: {
      title: '个人资料收集声明',
      p: '',
      list1: ['主办机构将会在参加者报名参与「远足植树日2019」行山活动并获即时确认出席资格时，收集参加者的个人资料，包括姓名、手提电话号码、电邮地址、病历记录、食物敏感资料等。主办机构保障参加者所提供之一切资料。当参加者提交确认时，有关个人资料将会被收集、储存及使用以作核实。',
        '本声明乃遵照《个人资料(私稳)条例》(第486章)的要求而发出，通知您作为参加者收集资料的目的、您同意主办机构如何使用这些资料及您的权利。本声明会不时更改，故请定期查阅。参加者每次登记及/或使用我们的服务时，即表示同意接受当时生效之个人资料收集声明。',
        '参加者可能会被要求向主办机构提供个人识别资料。为让参加者可以参加「远足植树日2019」行山活动，该些资料是必要的。倘若参加者未能提供所需资料，参加者将不能获得活动参加资格。',
      ],
      list2: ['识别和核实参加活动的参加者的身份及/或资格；',
        '就有关或因参加活动的事项与参加者或其紧急联系人沟通；',
        '汇编参加者的整体统计资料，分析、评估及改进主办机构所提供的活动',],
      list3: ['参加者之个人资料将被保密。然而由于系统管理、运作及保养需要，主办机构会将有关资料转移或披露予对主办机构有保密责任并提供与主办机构运作有关行政、电讯、电脑系统服务、数据处理或其他服务的承办商。',
        '参加者有权根据《个人资料（私隐）条例》(第486章)的规定，要求查阅或更正参加者之个人资料。如有任何查阅或更正资料的要求，请向中国移动香港的公司资料保障主任提出，其办事处位于香港新界葵涌葵昌路51号九龙贸易中心1座20楼。中国移动香港的私隐政策声明可于其网页www.hk.chinamobile.com获取。'
      ],
      list: ['资料之目的及用途', '主办机构所收集之资料将用作以下用途：', '资料之转移',]
    }
  }
}


// WEBPACK FOOTER //
// ./src/locale/activity/zh-cn.js